<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: '',
  mounted() {
    this.test();
  },
  methods: {
    test() {
      axios
        .get(
          `http://uappweb-pre.huolala.cn/index.php?android_id=a5d52ebf451a3df0&imei=868455036470802&client_type=1&_token=1b41145558664f2ab790c63b2f863379&brand=Meizu&token=1b41145558664f2ab790c63b2f863379&user_fid=DEkjjpVn&_m=consignee_order_detail&_su=22071317472370310000001475809531&city_id=1002&os_type=android&order_uuid=10022071315460324610020026121969&user_id=DEkjjpVn&device_id=02%3A00%3A00%3A00%3A00%3A00&portType=hlluser&version=6672&h_device_id=a5d52ebf451a3df0&oaid=e6e5c629a099b5bcecf0511899eaa367&model=16th${encodeURIComponent(
            '+',
          )}Plus`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
            //           params: {
            // _m: 'cs_chat',
            // hcountry: 90000,
            // query: {queue_info:"HK_HKG_ZH_DRIVER_CHAT"}
            //           },
          },
        )
        .then((res) => {
          console.log('res', res);
        });
    },
  },
};
</script>
<style lang="less">
html,
body {
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
